import http, { setEnv, setLang } from './http';

export function setConfig({ env, lang }) {
  if (env) {
    setEnv(env);
  }
  if (lang) {
    setLang(lang);
  }
}

export async function getTicketDataWithOrder({ orderNumber, channelId }) {
  const response = await http.post('/ticket-data', {
    o: orderNumber,
    channel_id: channelId,
  });

  return response;
}

export async function getTicketDataSingle({ ticketNumber, channelId }) {
  const response = await http.post('/ticket-data', {
    t: ticketNumber,
    channel_id: channelId,
  });

  return response;
}

export async function getTicketDataUrl({ url, query }) {
  const response = await http.post('/ticket-data', {
    u: url,
    q: query,
  });

  return response;
}

export async function getQrData({ orderNumber, attendeePedulilindungiIds, qr }) {
  const response = await http.post('/ticket-data/peduli-lindungi/qr', {
    o: orderNumber,
    a: attendeePedulilindungiIds,
    qr,
  });

  return response;
}

export async function checkinQr({
  orderNumber,
  attendeePedulilindungiIds,
  qr,
  latitude,
  longitude,
  group,
}) {
  const payload = {
    o: orderNumber,
    a: attendeePedulilindungiIds,
    qr,
    lat: latitude,
    lon: longitude,
  };
  if (group) {
    payload.group = group;
  }
  const response = await http.post('/ticket-data/peduli-lindungi/scan', payload);

  return response;
}
